var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-container",on:{"mouseenter":_vm.handleMouseEnter,"mousemove":_vm.handleMouseMove,"mouseleave":_vm.handleMouseLeave}},[_c('img',{ref:"normal",staticClass:"normal-image",attrs:{"src":_vm.src,"alt":_vm.title}}),_vm._v(" "),_c('img',{ref:"zoomed",staticClass:"zoomed-image",style:({
			transform: `scale(${_vm.scale})`,
			left: `${_vm.zoomedX}px`,
			top: `${_vm.zoomedY}px`
		}),attrs:{"src":_vm.zoomedSrc || _vm.src,"alt":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }